import axios from 'axios'

export function findSmartCar(data) {
    return axios({
        method: 'get',
        url:'/user/smartCar/carList',
        params: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function findSmartCarWxb(data) {
    return axios({
        method: 'get',
        url: '/user/car/findVisitCarInfo',
        params: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function updateForm(data) {
    return axios({
        method: 'post',
        url:'/user/smartCar/update',
        data: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function getUserType(data) {
    return axios({
        method: 'get',
        url:'/user/common/getParamater?paratype='+data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}


export function addSmartCar(data) {
    return axios({
        method: 'post',
        url:'/user/smartCar/add',
        data: data ,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}


export function delSmartCar(data) {
    return axios({
        method: 'delete',
        url:'/user/car/deleteCar?id='+data,
        data: data ,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function findCarInOut(data) {
    return axios({
        method: 'post',
        url:'/user/car/findCarInOut',
        data: data ,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function findCarInOutNew(data) {
    return axios({
        method: 'get',
        url:'/user/smartCarFlowNew/findCarFlowList',
        params: data ,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function getCarGj(data) {
    return axios({
        method: 'get',
        url: '/user/car/getCarGj',
        params: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function getCarGjNew(data) {
    return axios({
        method: 'get',
        url: '/user/smartCarFlowNew/getCarGj',
        params: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}
